import React from 'react'

import { Confetti } from 'components/common/ReactLottieBase'
import Text from 'components/common/Text'

import { isCorrectOrIncorrect } from './helper'
import * as Styles from './styles'

import { responseTypes } from '../../constants'

const Base = ({ type, iconPath, title, isTeacher, answersCount }) => {
    const titleColor = isCorrectOrIncorrect(type) ? 'white' : 'black'

    return (
        <Styles.Container $type={type}>
            {type === responseTypes.CORRECT ? (
                <Styles.LottieContainer>
                    <Confetti />
                </Styles.LottieContainer>
            ) : null}

            <Styles.BannerContainer $type={type} $isTeacher={isTeacher}>
                {!isTeacher && (
                    <Styles.IconContainer>
                        <Styles.Image src={iconPath} />
                    </Styles.IconContainer>
                )}
                <Text level="7" color={titleColor} className="title">
                    {title}
                </Text>
            </Styles.BannerContainer>
            <Styles.PointsContainer $type={type} $isTeacher={isTeacher}>
                {isTeacher && (
                    <Styles.QuestionStatistics>
                        <Styles.ResponseType>
                            <Styles.Indicator
                                category={responseTypes.CORRECT}
                            />
                            <Text level="3">
                                {`${answersCount.correct} Correct`}
                            </Text>
                        </Styles.ResponseType>
                        <Styles.ResponseType>
                            <Styles.Indicator
                                category={responseTypes.INCORRECT}
                            />
                            <Text level="3">
                                {`${answersCount.incorrect} Incorrect`}
                            </Text>
                        </Styles.ResponseType>
                        <Styles.ResponseType>
                            <Styles.Indicator
                                category={responseTypes.SKIPPED}
                            />
                            <Text level="3">
                                {`${answersCount.unattempted} Skipped`}
                            </Text>
                        </Styles.ResponseType>
                    </Styles.QuestionStatistics>
                )}
            </Styles.PointsContainer>
        </Styles.Container>
    )
}

export default Base
